<template>
  <Modal
  :value="open"
  :onClose="close"
  :close="false"
  title="Teclas de Atalhos"
  >
    <div class="row">
      <div class="col">
        <ul class="col modal-atalhos atalhos">
          <li><a> Configurações <span>(ALT + F1)</span></a></li>
          <li><a> Lançar Item <span>(F2)</span></a></li>
          <li><a> Desconto <span>(ALT + F7)</span></a></li>
          <li><a> Desconto para o próximo item<span>(ALT + F8)</span></a></li>
          <li><a> Informar Cliente <span>(ALT + F9)</span></a></li>
          <li><a> Informar Pagamento <span>(ALT + F10)</span></a></li>
          <li><a> Cancelar Último Item<span>(F4)</span></a></li>
          <li><a> Cancelar Item<span>(- Posição do Item)</span></a></li>
          <li><a> Cancelar Venda <span>(F6)</span></a></li>
          <li><a> Finalizar Venda <span>(F3)</span></a></li>
          <li><a> Importar Pedido de Venda <span>(Insert)</span></a></li>
          <li v-if="hasChangePrice"><a> Alterar Valor Unitário <span>(ALT + F11)</span></a></li>
        </ul>
      </div>
    </div>
    <div class="confirm-buttons">
      <Button type="error" @click="close()">Fechar</Button>
    </div>
  </Modal>
</template>

<script>
import { Modal } from '@/components';
import { Button } from '@/components/Form';

export default {
  name: 'ModalAtalhos',
  components: {
    Modal,
    Button,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    close: {
      type: Function,
      required: true,
    },
    hasChangePrice: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
  .modal-atalhos li {
    margin-bottom: 10px !important;
    cursor: auto!important;
  }
</style>
